package org.zq.flvtomp4.ui.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.remember
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import flvtomp4_master.app.shared.generated.resources.Res
import flvtomp4_master.app.shared.generated.resources.noto_sans_sc_black
import flvtomp4_master.app.shared.generated.resources.noto_sans_sc_bold
import flvtomp4_master.app.shared.generated.resources.noto_sans_sc_light
import flvtomp4_master.app.shared.generated.resources.noto_sans_sc_medium
import flvtomp4_master.app.shared.generated.resources.noto_sans_sc_regular
import org.jetbrains.compose.resources.Font

val LocalAppFontFamily = staticCompositionLocalOf<FontFamily> { FontFamily.Default }

@Composable
fun rememberAppFontFamily(): FontFamily {
    return FontFamily(
        Font(Res.font.noto_sans_sc_light, weight = FontWeight.Light),
        Font(Res.font.noto_sans_sc_regular, weight = FontWeight.Normal),
        Font(Res.font.noto_sans_sc_medium, weight = FontWeight.Medium),
        Font(Res.font.noto_sans_sc_bold, weight = FontWeight.Bold),
        Font(Res.font.noto_sans_sc_black, weight = FontWeight.Black),
    )
}

@Composable
fun AppTheme(content: @Composable () -> Unit) {
    val fontFamily = rememberAppFontFamily()
    val typography = remember(fontFamily) {
        Typography().withFontFamily(fontFamily)
    }

    CompositionLocalProvider(LocalAppFontFamily provides fontFamily) {
        MaterialTheme(
            typography = typography,
            content = content,
        )
    }
}

private fun Typography.withFontFamily(fontFamily: FontFamily): Typography {
    fun TextStyle.applyFont() = copy(fontFamily = fontFamily)

    return copy(
        displayLarge = displayLarge.applyFont(),
        displayMedium = displayMedium.applyFont(),
        displaySmall = displaySmall.applyFont(),
        headlineLarge = headlineLarge.applyFont(),
        headlineMedium = headlineMedium.applyFont(),
        headlineSmall = headlineSmall.applyFont(),
        titleLarge = titleLarge.applyFont(),
        titleMedium = titleMedium.applyFont(),
        titleSmall = titleSmall.applyFont(),
        bodyLarge = bodyLarge.applyFont(),
        bodyMedium = bodyMedium.applyFont(),
        bodySmall = bodySmall.applyFont(),
        labelLarge = labelLarge.applyFont(),
        labelMedium = labelMedium.applyFont(),
        labelSmall = labelSmall.applyFont(),
    )
}
